import axios from 'axios';
import { store } from './../store';
import { serverErrors } from './server-error';
import { setMessage } from './../actions/setMessage';
import { logoutRequestValid } from '../modules/auth/actions/postLogout';
import { route } from '../routes/web';

function json(response) {
    return response.data;
}
axios.interceptors.request.use((config) => {
    const bearer = localStorage.getItem('bearer');
    if (config.needAuth && bearer) {
        config.headers.Authorization = `Bearer ${bearer}`;
    }
    return config;
});

export function getToken() {
    return localStorage.getItem('bearer');
}
export function setToken(token) {
    localStorage.setItem('bearer', token);
}
export function removeToken() {
    localStorage.removeItem('bearer');
}

function invalidateUser() {
    return (dispatch) => {
        dispatch(logoutRequestValid());
        removeToken();
    };
}
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const config = error.config;
        const dispatch = store.dispatch;
        if (
            error.response?.status === 401 &&
            config.retry !== true &&
            config.intercept
        ) {
            const token = getToken();
            if (!token) dispatch(invalidateUser());
            config.retry = true;
            return new Promise((resolve, reject) => {
                request(
                    route.auth.refresh,
                    {},
                    (data) => {
                        if (data.access_token) {
                            setToken(data.access_token);
                            resolve(axios.request(config));
                        }
                    },
                    (error) => {
                        if (error?.response?.status === 401)
                            dispatch(invalidateUser());
                    }
                );
            });
        }
        return Promise.reject(error);
    }
);

export function request(route, data, valid, invalid, transformUrl) {
    const // _route = window.location.origin + '/',
        dispatch = store.dispatch;
    let options = {
        url:
            (typeof transformUrl === 'function'
                ? transformUrl(route.url)
                : route.url) || '',
        method: route.method,
        needAuth: route.auth !== false,
        intercept: route.intercept !== false,
    };

    if (route.method === 'post') {
        if (data && typeof data === 'object' && data.isFormData) {
            const formData = new FormData();
            for (let item in data) {
                if (data.hasOwnProperty(item)) {
                    formData.append(item, data[item]);
                }
            }
            data = formData;
        }
        options = { ...options, data: data };
    } else {
        options.url += data ? '/' + data : '';
    }

    axios(options)
        .then(json)
        .then((data) => {
            if (typeof valid === 'function') {
                valid(data);
            }
        })
        .catch((error) => {
            console.error('Request catch:', error);
            if (error.response) {
                if (serverErrors.hasOwnProperty(error.response.status)) {
                    dispatch(
                        setMessage(serverErrors[error.response.status], 'error')
                    );
                } else {
                    dispatch(setMessage('Неопознанная ошибка', 'error'));
                }
            } else {
                dispatch(
                    setMessage(
                        'Ошибочка вышла. Обновите и попробуйте снова.',
                        'error'
                    )
                );
            }
            if (typeof invalid === 'function') {
                invalid(error);
            }
        });
}
